/**
 * Query key factories for chat history data.
 */
export const chatHistoryKeys = {
  all: (viewerId: string) => ["chat_history", viewerId] as const,
  list: (viewerId: string) =>
    [...chatHistoryKeys.all(viewerId), "list"] as const,
  messagesAll: (viewerId: string) =>
    [...chatHistoryKeys.all(viewerId), "messages"] as const,
  messages: (viewerId: string, chatId: string) =>
    [...chatHistoryKeys.messagesAll(viewerId), chatId] as const,
};
